/**
 * Script simple de gestion de la galerie média avec metafields de variantes
 * Ne fait que masquer/afficher les groupes d'images pré-chargées
 */

class VariantMediaGallery {
  constructor() {
    this.variantData = null;
    this.currentVariantId = null;
    this.isInitialized = false;
    this.sectionId = null;
    
    this.init();
  }
  
  init() {
    if (this.isInitialized) return;
    
    console.log('=== VARIANT MEDIA GALLERY INIT ===');
    
    const mediaGallery = document.querySelector('media-gallery[data-section-id]');
    if (!mediaGallery) {
      console.warn('Media gallery not found');
      return;
    }
    
    this.sectionId = mediaGallery.dataset.sectionId;
    this.loadVariantData();
    this.bindEvents();
    this.syncInitialState();
    
    this.isInitialized = true;
    console.log('=== VARIANT MEDIA GALLERY READY ===');
  }
  
  loadVariantData() {
    const dataScript = document.querySelector(`#variant-metafields-data-${this.sectionId}`);
    if (!dataScript) {
      console.warn('Variant data not found');
      return;
    }
    
    try {
      this.variantData = JSON.parse(dataScript.textContent);
      console.log('Variant data loaded:', Object.keys(this.variantData.variants).length, 'variants');
    } catch (error) {
      console.error('Error loading variant data:', error);
    }
  }
  
  bindEvents() {
    // 1. Écouter les événements PUB_SUB (priorité haute)
    if (typeof subscribe === 'function' && typeof window.PUB_SUB_EVENTS !== 'undefined') {
      subscribe(window.PUB_SUB_EVENTS.optionValueSelectionChange, (data) => {
        console.log('PUB_SUB optionValueSelectionChange:', data);
        // Délai plus long pour laisser VariantSelects finir ses ajustements
        setTimeout(() => {
          this.checkForVariantChange();
        }, 100);
      });
    }

    // 2. Écouter directement l'input de variante (backup)
    document.addEventListener('change', (e) => {
      if (e.target.name === 'id' && e.target.type === 'hidden') {
        const variantId = parseInt(e.target.value);
        if (variantId && variantId !== this.currentVariantId) {
          console.log('Direct variant input change to:', variantId);
          this.onVariantChange({ variant: { id: variantId } });
        }
      }
    });
    
    // 3. Observer DOM pour les changements programmatiques
    this.observeVariantChanges();
    
    // 4. Écouter les changements d'options (délai adapté)
    document.addEventListener('change', (e) => {
      if (e.target.type === 'radio' && e.target.name && e.target.name.includes('options[')) {
        // Délai plus long pour laisser VariantSelects ajuster
        setTimeout(() => {
          this.checkForVariantChange();
        }, 150);
      }
    });
    
    document.addEventListener('change', (e) => {
      if (e.target.tagName === 'SELECT' && e.target.name && e.target.name.includes('options[')) {
        setTimeout(() => {
          this.checkForVariantChange();
        }, 150);
      }
    });
  }
  
  checkForVariantChange() {
    const productForm = document.querySelector('product-form, [data-product-form]');
    if (!productForm) return;
    
    const variantInput = productForm.querySelector('input[name="id"]');
    if (!variantInput) return;
    
    const variantId = variantInput.value;
    
    // Gérer le cas où la variante est vide/invalide
    if (!variantId || variantId === '' || variantId === 'null') {
      console.log('No valid variant selected, showing default');
      this.currentVariantId = null;
      this.hideAllGroups();
      this.showDefaultGroup();
      this.updateCounter();
      this.resetSliders();
      return;
    }
    
    const numericVariantId = parseInt(variantId);
    if (numericVariantId && numericVariantId !== this.currentVariantId) {
      console.log('Variant change detected:', numericVariantId);
      this.onVariantChange({ variant: { id: numericVariantId } });
    }
  }
  
  observeVariantChanges() {
    const productForm = document.querySelector('product-form, [data-product-form]');
    if (!productForm) return;
    
    const variantInput = productForm.querySelector('input[name="id"]');
    if (!variantInput) return;
    
    // Observer les changements de l'attribut value
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
          const newVariantId = parseInt(variantInput.value);
          if (newVariantId && newVariantId !== this.currentVariantId) {
            console.log('Variant observed change to:', newVariantId);
            this.onVariantChange({ variant: { id: newVariantId } });
          }
        }
      });
    });
    
    observer.observe(variantInput, {
      attributes: true,
      attributeFilter: ['value']
    });
  }
  
  onVariantChange(data) {
    const variantId = data.variant ? data.variant.id : null;
    
    if (!variantId || variantId === this.currentVariantId) return;
    
    console.log('=== VARIANT CHANGE ===', variantId);
    
    this.currentVariantId = variantId;
    this.switchMediaGroup(variantId);
  }
  
  switchMediaGroup(variantId) {
    if (!this.variantData || !this.variantData.variants) return;
    
    const variant = this.variantData.variants[variantId.toString()];
    if (!variant) {
      console.warn('Variant not found:', variantId);
      return;
    }
    
    this.hideAllGroups();
    
    if (variant.has_custom_slides) {
      this.showVariantGroup(variantId);
      console.log('Showing variant group:', variantId);
    } else {
      this.showDefaultGroup();
      console.log('Showing default group');
    }
    
    this.updateCounter();
    this.resetSliders();
  }
  
  hideAllGroups() {
    // Masquer tous les éléments par défaut
    const defaultMediaItems = document.querySelectorAll('.default-media-item');
    defaultMediaItems.forEach(item => {
      item.style.display = 'none';
      item.classList.remove('is-active');
    });
    
    const defaultThumbnailItems = document.querySelectorAll('.default-thumbnail-item');
    defaultThumbnailItems.forEach(item => {
      item.style.display = 'none';
      const button = item.querySelector('button');
      if (button) {
        button.removeAttribute('aria-current');
      }
    });
    
    // Masquer TOUS les éléments de TOUTES les variantes (pas seulement la variante courante)
    const allVariantMediaItems = document.querySelectorAll('.variant-media-item');
    allVariantMediaItems.forEach(item => {
      item.style.display = 'none';
      item.classList.remove('is-active');
    });
    
    const allVariantThumbnailItems = document.querySelectorAll('.variant-thumbnail-item');
    allVariantThumbnailItems.forEach(item => {
      item.style.display = 'none';
      const button = item.querySelector('button');
      if (button) {
        button.removeAttribute('aria-current');
      }
    });
  }
  
  showVariantGroup(variantId) {
    // D'abord, garder l'image par défaut visible si c'est la même que la featured de la variante
    const defaultMediaItem = document.querySelector('.default-media-item');
    const variantFeaturedItem = document.querySelector(`[data-media-id*="variant-${variantId}-featured"]`);
    
    // Si la variante a une featured image différente de celle par défaut, ou n'en a pas
    if (variantFeaturedItem) {
      // Il y a une featured image spécifique à la variante, masquer la par défaut
      if (defaultMediaItem) {
        defaultMediaItem.style.display = 'none';
        defaultMediaItem.classList.remove('is-active');
      }
      // Afficher la featured de variante
      variantFeaturedItem.style.display = 'block';
      variantFeaturedItem.classList.add('is-active');
    } else {
      // Pas de featured spécifique, garder celle par défaut active
      if (defaultMediaItem) {
        defaultMediaItem.style.display = 'block';
        defaultMediaItem.classList.add('is-active');
      }
    }
    
    // Afficher les images de metafields de cette variante
    const variantMetafieldItems = document.querySelectorAll(`[data-media-group="variant-${variantId}"]:not([data-media-id*="-featured"])`);
    variantMetafieldItems.forEach((item, index) => {
      item.style.display = 'block';
      // Ne pas ajouter is-active aux metafields si une featured image est déjà active
    });
    
    // Même logique pour les thumbnails
    const defaultThumbnailItem = document.querySelector('.default-thumbnail-item');
    const variantFeaturedThumbnail = document.querySelector(`[data-target*="variant-${variantId}-featured"]`);
    
    if (variantFeaturedThumbnail) {
      if (defaultThumbnailItem) {
        defaultThumbnailItem.style.display = 'none';
        const button = defaultThumbnailItem.querySelector('button');
        if (button) button.removeAttribute('aria-current');
      }
      variantFeaturedThumbnail.style.display = 'block';
      const button = variantFeaturedThumbnail.querySelector('button');
      if (button) button.setAttribute('aria-current', 'true');
    } else {
      if (defaultThumbnailItem) {
        defaultThumbnailItem.style.display = 'block';
        const button = defaultThumbnailItem.querySelector('button');
        if (button) button.setAttribute('aria-current', 'true');
      }
    }
    
    const variantMetafieldThumbnails = document.querySelectorAll(`[data-thumbnail-group="variant-${variantId}"]:not([data-target*="-featured"])`);
    variantMetafieldThumbnails.forEach((item) => {
      item.style.display = 'block';
    });
  }
  
  showDefaultGroup() {
    const defaultMediaItems = document.querySelectorAll('.default-media-item');
    defaultMediaItems.forEach((item, index) => {
      item.style.display = 'block';
      if (index === 0) {
        item.classList.add('is-active');
      }
    });
    
    const defaultThumbnailItems = document.querySelectorAll('.default-thumbnail-item');
    defaultThumbnailItems.forEach((item, index) => {
      item.style.display = 'block';
      if (index === 0) {
        const button = item.querySelector('button');
        if (button) {
          button.setAttribute('aria-current', 'true');
        }
      }
    });
  }
  
  updateCounter() {
    const visibleSlides = document.querySelectorAll('.product__media-item:not([style*="display: none"])');
    const totalCount = visibleSlides.length;
    
    const counterTotal = document.querySelector('.slider-counter--total');
    if (counterTotal) {
      counterTotal.textContent = totalCount;
    }
    
    const counterCurrent = document.querySelector('.slider-counter--current');
    if (counterCurrent) {
      counterCurrent.textContent = '1';
    }
  }
  
  resetSliders() {
    const mainSlider = document.querySelector('.product__media-list');
    if (mainSlider) {
      mainSlider.scrollLeft = 0;
    }
    
    const thumbnailSlider = document.querySelector('.thumbnail-list');
    if (thumbnailSlider) {
      thumbnailSlider.scrollLeft = 0;
    }
    
    const sliderComponent = document.querySelector('slider-component');
    if (sliderComponent && typeof sliderComponent.resetPages === 'function') {
      setTimeout(() => {
        sliderComponent.resetPages();
      }, 100);
    }
  }
  
  syncInitialState() {
    const productForm = document.querySelector('product-form, [data-product-form]');
    if (!productForm) return;
    
    const variantInput = productForm.querySelector('input[name="id"]');
    if (variantInput && variantInput.value) {
      const variantId = parseInt(variantInput.value);
      console.log('=== SYNC INITIAL STATE ===', variantId);
      this.switchMediaGroup(variantId);
    } else {
      this.showDefaultGroup();
    }
  }
  
  getDebugInfo() {
    return {
      initialized: this.isInitialized,
      currentVariant: this.currentVariantId,
      sectionId: this.sectionId,
      variantDataLoaded: !!this.variantData,
      variantCount: this.variantData ? Object.keys(this.variantData.variants).length : 0,
      visibleMediaItems: document.querySelectorAll('.product__media-item:not([style*="display: none"])').length,
      visibleThumbnailItems: document.querySelectorAll('.thumbnail-list__item:not([style*="display: none"])').length
    };
  }
  
  forceVariant(variantId) {
    this.switchMediaGroup(parseInt(variantId));
  }
}

function initVariantMediaGallery() {
  const mediaGallery = document.querySelector('media-gallery[data-section-id]');
  const variantDataScript = document.querySelector('[id^="variant-metafields-data-"]');
  
  if (mediaGallery && variantDataScript) {
    window.variantMediaGallery = new VariantMediaGallery();
    
    if (window.location.search.includes('debug=variant-media')) {
      console.log('=== DEBUG VARIANT MEDIA ENABLED ===');
      window.variantMediaDebug = {
        gallery: window.variantMediaGallery,
        info: () => window.variantMediaGallery.getDebugInfo(),
        forceVariant: (variantId) => window.variantMediaGallery.forceVariant(variantId)
      };
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVariantMediaGallery);
} else {
  initVariantMediaGallery();
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = VariantMediaGallery;
}